import React from 'react';
import { useTranslation } from 'react-i18next';
import DiagnosticCriteriaTable from '../../components/DiagnosticCriteriaTable';
import IpsetCalculator from './IpsetCalculator';
import { etDiagnosticCriteria } from '../../data/diseasesData';

interface EtViewProps {
  activeTab: string;
}

const EtView: React.FC<EtViewProps> = ({ activeTab }) => {
  const { t } = useTranslation('hematology');

  // ET diagnosis rule: all 4 major, OR first 3 major + 1 minor
  const evaluateEtDiagnosis = (majorMet: number[], minorMet: number[]) => {
    const allFourMajor = [1, 2, 3, 4].every((n) => majorMet.includes(n));
    const firstThreeMajorPlusMinor =
      [1, 2, 3].every((n) => majorMet.includes(n)) && minorMet.length >= 1;

    if (allFourMajor) {
      return { met: true, label: t('et.diagnosisMet4Major') };
    }
    if (firstThreeMajorPlusMinor) {
      return { met: true, label: t('et.diagnosisMetMajorMinor') };
    }
    return { met: false, label: t('et.diagnosisNotMet') };
  };

  switch (activeTab) {
    case 'diagnosis':
      return (
        <DiagnosticCriteriaTable
          criteria={etDiagnosticCriteria}
          title={t('et.diagnosisTitle')}
          subtitle={t('et.diagnosisSubtitle')}
          stateKey="etDiagnosisCriteria"
          evaluateDiagnosis={evaluateEtDiagnosis}
        />
      );
    case 'risk':
      return <IpsetCalculator />;
    default:
      return null;
  }
};

export default EtView;
